<template>
  <div>
    <div class="d-flex">
      <div class="mr-auto">
        <el-tooltip content="Refresh" placement="top" effect="light">
          <button class="btn btn-secondary" @click="refresh">
            <i class="fas fa-sync-alt fa-fw"></i>
          </button>
        </el-tooltip>
        <slot name="buttons"></slot>
      </div>
    </div>
    <base-table
        :base-url="this.url"
        ref="baseTable"
        @load-success="onLoadSuccess"
        @refresh="onRefresh"
        v-loading="isRefreshing"
        element-loading-spinner="el-icon-loading"
    >
      <template v-slot>
        <el-table
            :data="items"
            stripe
            class="w-100"
        >
          <el-table-column
              prop="model.pid"
              label="PID"
              min-width="80"
          ></el-table-column>
          <el-table-column
              prop="model.started_at"
              label="Started"
              :formatter="formatStartedAt"
              min-width="100"
          ></el-table-column>
          <el-table-column
              prop="model.duration"
              label="Active"
              min-width="120"
          ></el-table-column>
          <el-table-column
              prop="model.query"
              label="Query"
              min-width="400"
          ></el-table-column>
          <el-table-column label="Actions" v-slot="{row}">
            <actions-column :row="row" @terminate="onTerminate"></actions-column>
          </el-table-column>
        </el-table>
      </template>
    </base-table>
  </div>
</template>

<script>
import BaseTable from '../../components/table-without-pagination';
import ActionsColumn from './actions-column';

export default {
  extends: BaseTable,

  components: {
    ActionsColumn,
  },

  methods: {
    /**
     * @return {undefined}
     */
    refresh() {
      this.$refs.baseTable.refresh();
    },

    /**
     * @return {string}
     */
    formatStartedAt(item, col, {datetime}) {
      return moment(datetime).format(config('format.moment.full.datetime'));
    },

    /**
     * @param {Object} row
     * @param {string} url
     */
    onTerminate({row, url}) {
      axios.post(url, {pid: row.model.pid})
          .then(res => {
            const message = _.get(res, 'data.message');
            _.isString(message) && this.$message.success(message);
          })
          .catch(err => {
            const message = _.get(err, 'response.data.message');
            _.isString(message) && this.$message.error(message);
          })
          .then(this.refresh());
    },
  },
}
</script>
